




























import { Component, Vue, PropSync } from "vue-property-decorator";

@Component
class ReferralSetSuccessModal extends Vue {
  @PropSync("visible") bindVisible!: boolean;

  handleToDownload() {
    this.$common.utils.helper.toFoxONEDownloadPage(this.$i18n.locale);
  }

  handleToHome() {
    this.$common.utils.helper.toFusionPath(this, "wallet", { name: "index" });
  }
}
export default ReferralSetSuccessModal;
